import { render } from "./appshow.vue?vue&type=template&id=4b129790&scoped=true"
import script from "./appshow.vue?vue&type=script&lang=js"
export * from "./appshow.vue?vue&type=script&lang=js"

import "./appshow.vue?vue&type=style&index=0&id=4b129790&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b129790"]])

export default __exports__